import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 659646 667122"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#2b2a29}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528323216704">
        <path
          d="M634835 667122H24811C11135 667122 0 655977 0 642301v-33190c0-13676 11135-24811 24811-24811h610024c13676 0 24811 11135 24811 24811v33190c0 13676-11135 24821-24811 24821zM24811 596701c-6799 0-12401 5533-12401 12410v33190c0 6798 5534 12410 12401 12410h610024c6799 0 12400-5533 12400-12410v-33190c0-6798-5523-12400-12400-12400l-610024-10z"
          className="fil0"
        />
        <path
          d="M607100 596701h-39164c-3443 0-6210-2757-6210-6200V49632H96497v540869c0 3443-2766 6200-6200 6200H51123c-3434 0-6200-2757-6200-6200V49632H24811C11135 49632 0 38497 0 24811 0 11135 11135 0 24811 0h610024c13676 0 24811 11135 24811 24811 0 13686-11135 24821-24811 24821h-21534v540869c0 3443-2767 6200-6201 6200zm-32963-12401h26763V43422c0-3434 2757-6201 6200-6201h27735c6799 0 12400-5533 12400-12410 0-6799-5523-12401-12400-12401H24811c-6799 0-12401 5524-12401 12401 0 6809 5534 12410 12401 12410h26312c3444 0 6210 2767 6210 6201v540878h26754V43422c0-3434 2766-6201 6210-6201h477639c3434 0 6201 2767 6201 6201v540878z"
          className="fil0"
        />
        <path
          d="M349366 596701h-39164c-3434 0-6201-2757-6201-6200v-49181c0-3443 2767-6210 6201-6210 3433 0 6200 2767 6200 6210v42980h26763v-42980c0-3443 2767-6210 6201-6210 3443 0 6210 2767 6210 6210v49181c0 3443-2767 6200-6210 6200zM130059 527938c-2619 0-5003-1716-5906-4189L84312 407444c-372-2021-372-363944-372-363944 0-3433 2766-6200 6210-6200h79603c3434 0 6200 2767 6200 6200v361923c-294 2021-40135 118326-40135 118326-677 2473-3071 4189-5759 4189zM96497 404384l33562 98214 33562-98214V49632H96428v354752h69z"
          className="fil0"
        />
        <path
          d="M209663 527938c-2610 0-5004-1716-5897-4189l-39841-116305c-304-2021-304-363944-304-363944 0-3433 2767-6200 6210-6200h79604c3433 0 6200 2767 6200 6200v361923c-373 2021-40135 118326-40135 118326-824 2473-3140 4189-5837 4189zm-33553-123554 33631 98214 33562-98214V49632h-67193v354752z"
          className="fil0"
        />
        <path
          d="M289276 527938c-2620 0-5014-1716-5906-4189l-39841-116305c-295-2021-295-363944-295-363944 0-3433 2757-6200 6201-6200h79603c3444 0 6200 2767 6200 6200v361923c-372 2021-40135 118326-40135 118326-824 2473-3139 4189-5827 4189zm-33562-123554 33630 98214 33562-98214V49632h-67192v354752z"
          className="fil0"
        />
        <path
          d="M368879 527938c-2619 0-5003-1716-5906-4189l-39841-116305c-294-2021-294-363944-294-363944 0-3433 2766-6200 6200-6200h79603c3444 0 6210 2767 6210 6200v361923c-372 2021-40145 118326-40145 118326-745 2473-3139 4189-5827 4189zm-33562-123554 33562 98214 33562-98214V49632h-67203v354752h79z"
          className="fil0"
        />
        <path
          d="M448482 527938c-2609 0-5003-1716-5906-4189l-39831-116305c-373-2021-373-363944-373-363944 0-3433 2757-6200 6201-6200h79603c3434 0 6200 2767 6200 6200v361923c-373 2021-40135 118326-40135 118326-677 2473-3061 4189-5759 4189zm-33562-123554 33562 98214 33562-98214V49632h-67193v354752h69z"
          className="fil0"
        />
        <path
          d="M528095 527938c-2619 0-5013-1716-5906-4189l-39841-116305c-372-2021-372-363944-372-363944 0-3433 2766-6200 6200-6200h79603c3444 0 6210 2767 6210 6200v361923c-304 2021-40145 118326-40145 118326-667 2473-3061 4189-5749 4189zm-33562-123554 33562 98214 33631-98214V49632h-67193v354752z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
